// src/api/testimonials.js
import api from "./axios";

// ---- Public ----
export const getPublicTestimonials = (params) => api.get("/api/public/testimonials/", { params });
export const getFeaturedTestimonials = (params) => api.get("/api/public/testimonials/featured/", { params });
export const getTestimonialById = (id) => api.get(`/api/public/testimonials/${id}/`);

// ---- Admin ----
export const adminGetTestimonials = (params) => api.get("/api/admin/testimonials/", { params });
export const adminGetTestimonialById = (id) => api.get(`/api/admin/testimonials/${id}/`);
export const adminCreateTestimonial = (data) => api.post("/api/admin/testimonials/", data);
export const adminUpdateTestimonial = (id, data) => api.patch(`/api/admin/testimonials/${id}/`, data);
export const adminDeleteTestimonial = (id) => api.delete(`/api/admin/testimonials/${id}/`);
export const adminSetTestimonialStatus = (id, isActive) => api.patch(`/api/admin/testimonials/${id}/status/`, { isActive });
export const adminSetTestimonialOrder = (id, displayOrder) => api.patch(`/api/admin/testimonials/${id}/order/`, { displayOrder });